export default __webpack_public_path__ + "static/media/feature.c7c175fb.svg";